import React, { useEffect } from "react";
import { createSelector } from "reselect";
// Components
import withRouter from "Components/Common/withRouter";
// Redux
import { useSelector } from "react-redux";

const NonAuthLayout = ({ children }: any) => {
  const nonauthData = createSelector(
    (state: any) => state.Layout.layoutModeType,
    (layoutModeType: any) => layoutModeType,
  );
  // Inside your component
  const layoutModeType = useSelector(nonauthData);

  useEffect(() => {
    if (layoutModeType === "dark") {
      document.body.setAttribute("data-bs-theme", "dark");
    } else {
      document.body.setAttribute("data-bs-theme", "light");
    }
    return () => {
      document.body.removeAttribute("data-bs-theme");
    };
  }, [layoutModeType]);
  return <div>{children}</div>;
};

export default withRouter(NonAuthLayout);
